import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Sparkles, Copy, Check as CheckIcon } from "lucide-react";

/** Diálogo com a carta de motivação gerada por IA. */
export const CoverLetterDialog = ({ letter, onClose, copied, onCopy, onRegenerate, generating }) => (
  <Dialog open={!!letter} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-heading font-black tracking-tighter">
          Carta de motivação — {letter?.jobTitle}
        </DialogTitle>
      </DialogHeader>
      <Textarea value={letter?.text || ""} readOnly rows={14}
        className="text-sm leading-relaxed resize-none bg-slate-50 border-slate-200" />
      <div className="flex flex-wrap gap-2 pt-1">
        <Button className="rounded-full flex-1 bg-slate-900 hover:bg-slate-800" onClick={onCopy}>
          {copied
            ? <><CheckIcon className="w-3.5 h-3.5 mr-1.5 text-emerald-400" /> Copiado!</>
            : <><Copy className="w-3.5 h-3.5 mr-1.5" /> Copiar carta</>}
        </Button>
        <Button variant="outline" className="rounded-full border-amber-400 text-amber-600 hover:bg-amber-50"
          disabled={generating} onClick={onRegenerate}>
          <Sparkles className="w-3.5 h-3.5 mr-1.5" />
          {generating ? "A gerar..." : "Gerar nova versão"}
        </Button>
      </div>
      <p className="text-[11px] text-slate-400 text-center">
        Revê e personaliza antes de enviar. A IA pode cometer erros.
      </p>
    </DialogContent>
  </Dialog>
);
